import React from "react";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext"; // Pfad ggf. anpassen
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useSiteSettings } from '../../context/SiteSettingsContext';


const ChangePassword: React.FC = () => {
    const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
    const logLevel = siteSettings?.frontend_log_level ?? 0;
    const auth = useContext(AuthContext);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [repeatNewPassword, setRepeatNewPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [showNewPasswordError, setShowNewPasswordError] = useState(false);

    const isFormValid =
        currentPassword.trim() !== "" &&
        newPassword.trim() !== "" &&
        repeatNewPassword.trim() !== "" &&
        newPassword === repeatNewPassword;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!auth) return;

        const passwordFormat = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).{6,}$/;

        if (!passwordFormat.test(newPassword)) {
            setShowNewPasswordError(true);
            return;
        } else {
            setShowNewPasswordError(false);
        }

        if (newPassword !== repeatNewPassword) {
            alert("Die neuen Passwörter stimmen nicht überein.");
            return;
        }

        try {
            const response = await fetch("/auth/api/change-password/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    old_password: currentPassword,
                    new_password: newPassword,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                const errorMsg = errorData.detail || "Fehler beim Ändern des Passworts.";
                throw new Error(errorMsg);
            }

            alert("Passwort erfolgreich geändert.");
            setCurrentPassword("");
            setNewPassword("");
            setRepeatNewPassword("");
        } catch (err) {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error("Fehler beim Ändern des Passworts:", err);
            alert("Fehler beim Ändern des Passworts.");
        }
    };

    return (
        <div className="tw-w-full tw-pt-6 lg:tw-pt-12 tw-pb-32 sm:tw-pb-0 tw-overflow-y-scroll scroll-hidden">
            <div className="profile-section tw-w-full max-w-6xl">
                <form data-gtm-form-interact-id="3" onSubmit={handleSubmit} autoComplete="off">
                    <div style={{ position: "absolute", left: "-10000px", top: "auto", width: 1, height: 1, overflow: "hidden" }} aria-hidden="true">
                        <input type="text" name="fake-username" autoComplete="username" tabIndex={-1} />
                        <input type="password" name="fake-password" autoComplete="current-password" tabIndex={-1} />
                    </div>
                    <div className="tw-flex tw-justify-between tw-items-center">
                        <h3 className="tw-text-xl tw-font-semibold tw-my-0">Passwort ändern</h3>
                        <div className="tw-z-10 sm:tw-flex tw-fixed sm:tw-relative tw-justify-center tw-w-screen sm:tw-w-fit !tw-bg-white tw-bottom-0 tw-left-0 tw-py-4 sm:tw-py-0 mobile-cta">
                            <button
                                type="submit"
                                disabled={!isFormValid}
                                className="_button_19rto_40 _purple_19rto_126 _filled_19rto_80 disabled:!tw-opacity-60 tw-cursor-pointer tw-px-10 tw-w-full sm:tw-w-fit"
                            >
                                <div className="_btnFlex_19rto_32">
                                    <p className="tw-m-0 tw-block tw-truncate !tw-text-base">Passwort speichern</p>
                                </div>
                            </button>
                        </div>
                    </div>

                    <div className="tw-flex tw-flex-col tw-space-y-3 tw-mt-3">
                        {/* Aktuelles Passwort */}
                        <div className="input__container" style={{ pointerEvents: "auto", opacity: 1 }}>
                            <label htmlFor="currentPassword" className="input__container__label tw-mt-3 !tw-text-[12px] !tw-font-normal">
                                Aktuelles Passwort
                            </label>
                            <div className="input__container__div ad-input__container text-[14px]">
                                <input
                                    className="input__container__div__input"
                                    type={showCurrentPassword ? "text" : "password"}
                                    name="currentPassword"
                                    id="currentPassword"
                                    inputMode="text"
                                    autoComplete="current-password"
                                    required
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                <div className="input__container__div__input__icon" onClick={() => setShowCurrentPassword(!showCurrentPassword)} style={{ cursor: "pointer", position: "relative", top: "-5px" }}>
                                      {showCurrentPassword ? <VisibilityOff /> : <Visibility />}

                                </div>              </div>
                        </div>

                        {/* Neues Passwort */}
                        <div className="input__container" style={{ pointerEvents: "auto", opacity: 1 }}>
                            <label htmlFor="newPassword" className="input__container__label tw-mt-3 !tw-text-[12px] !tw-font-normal">
                                Neues Passwort
                            </label>
                            <div className="input__container__div ad-input__container text-[14px]">
                                <input
                                    className="input__container__div__input"
                                    type={showNewPassword ? "text" : "password"}
                                    name="newPassword"
                                    id="newPassword"
                                    inputMode="text"
                                    autoComplete="new-password"
                                    required
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <div className="input__container__div__input__icon" onClick={() => setShowNewPassword(!showNewPassword)} style={{ cursor: "pointer", position: "relative", top: "-5px" }}>
                                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </div></div>{showNewPasswordError && (
            <p className="input__container__div__error !tw-text-xs">
              Das Passwort muss mindestens 6 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.
            </p>)}  
                        </div>

                        {/* Passwort-Hinweise (momentan hidden) */}
                        <div className="tw-text-[14px] tw-h-fit !tw-mt-2 tw-hidden">
                            <ul className="tw-list-none tw-text-[14px] tw-my-0 tw-mt-1 tw-px-0">
                                <li className="tw-text-[#707070] tw-flex tw-items-center tw-gap-x-2 tw-ml-0 tw-mt-1">
                                    <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                                        <span className="tw-border-2 tw-border-solid tw-border-[#707070] tw-rounded-full"></span>
                                    </div>
                                    <p className="tw-m-0 tw-text-xs">Großbuchstaben</p>
                                </li>
                                <li className="tw-text-[#707070] tw-flex tw-items-center tw-gap-x-2 tw-ml-0 tw-mt-1">
                                    <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                                        <span className="tw-border-2 tw-border-solid tw-border-[#707070] tw-rounded-full"></span>
                                    </div>
                                    <p className="tw-m-0 tw-text-xs">Kleinbuchstaben</p>
                                </li>
                                <li className="tw-text-[#707070] tw-flex tw-items-center tw-gap-x-2 tw-ml-0 tw-mt-1">
                                    <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                                        <span className="tw-border-2 tw-border-solid tw-border-[#707070] tw-rounded-full"></span>
                                    </div>
                                    <p className="tw-m-0 tw-text-xs">Zahlen</p>
                                </li>
                                <li className="tw-text-[#707070] tw-flex tw-items-center tw-gap-x-2 tw-ml-0 tw-mt-1">
                                    <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                                        <span className="tw-border-2 tw-border-solid tw-border-[#707070] tw-rounded-full"></span>
                                    </div>
                                    <p className="tw-m-0 tw-text-xs">Sonderzeichen (z. B. !, @, #, $, %)</p>
                                </li>
                                <li className="tw-text-[#707070] tw-flex tw-items-center tw-gap-x-2 tw-ml-0 tw-mt-1">
                                    <div className="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
                                        <span className="tw-border-2 tw-border-solid tw-border-[#707070] tw-rounded-full"></span>
                                    </div>
                                    <p className="tw-m-0 tw-text-xs">Mindestens 6 Zeichen</p>
                                </li>
                            </ul>
                        </div>

                        {/* Passwort bestätigen */}
                        <div className="input__container" style={{ pointerEvents: "auto", opacity: 1 }}>
                            <label htmlFor="repeatNewPassword" className="input__container__label tw-mt-3 !tw-text-[12px] !tw-font-normal">
                                Neues Passwort bestätigen
                            </label>
                            <div className="input__container__div ad-input__container text-[14px]">
                                <input
                                    className="input__container__div__input"
                                    type={showRepeatPassword ? "text" : "password"}
                                    name="repeatNewPassword"
                                    id="repeatNewPassword"
                                    inputMode="text"
                                    autoComplete="new-password"
                                    required
                                    value={repeatNewPassword}
                                    onChange={(e) => setRepeatNewPassword(e.target.value)}
                                />
                                <div className="input__container__div__input__icon" onClick={() => setShowRepeatPassword(!showRepeatPassword)} style={{ cursor: "pointer", position: "relative", top: "-5px" }}>
                                    {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                                </div>                               </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
